/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material/styles';
import {withStyles} from '@mui/styles';
import LinearProgress from '@mui/material/LinearProgress';

const styles = {
  root: {
    flexGrow: 1,
    fontSize: '2rem',
  },
};

function LinearIndeterminate(props) {
  const {classes} = props;
  return (
    <div className={classes.root}>
      <LinearProgress />
    </div>
  );
}

LinearIndeterminate.propTypes = {
  classes: PropTypes.object.isRequired,
};

const Progress = withStyles(styles)(LinearIndeterminate);

function ResponsiveDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = React.useState(true);

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">Čeká se na potvrzení emailu</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Na email {props.email} byl odeslán potvrzující odkaz. Po kliknutí na odkaz bude možné nastavit nové heslo.
          </DialogContentText>
        </DialogContent>
        <Progress />
      </Dialog>
    </div>
  );
}

export default ResponsiveDialog;
